import { FileText } from 'lucide-react';

export default function Tadfeen() {

  const maleContacts = [
    { name: 'Mohammed bhai Tapia', phone: '+1 (848) 702-2620' },
    { name: 'Shaikh Idris Bhai Diwan', phone: '917-968-9303' }, // swapped ↑
    { name: 'Shaikh Shakir Bhai Jamali', phone: '732-904-3969' }, // swapped ↓
    { name: 'Mulla Najmuddin bhai Tasnim', phone: '+1 (201) 736-2937' },
    { name: 'Hashim bhai Chittalwala', phone: '+1 (732) 781-5242' },
    { name: 'Mulla Saifuddin bhai Furniturewalla', phone: '+1 (732) 910-6252' },
    { name: 'AliAsghar bhai Ghasletwala', phone: '+1 (609) 510-4298' },
    { name: 'Shaikh Kutubuddin bhai Kapadia', phone: '973-277-4556' }
  ];

  const femaleContacts = [
    { name: 'Mulla Tahera ben Zakir', phone: '732-925-1161' },
    { name: 'Sakina ben Diwan', phone: '917-751-7717' },
    { name: 'Maryam ben Khomusi', phone: '609-619-2608' }
  ];

  return (
    <div className="min-h-screen bg-white">

      {/* Hero */}
      <div className="relative py-24 text-white" style={{ background: 'linear-gradient(135deg, #001f3f 0%, #003d66 100%)' }}>
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="font-playfair text-5xl md:text-6xl font-bold">Tadfeen Committee</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">

        

        {/* Committee Contacts */}
        <div>
          <h2 className="font-playfair text-4xl font-bold text-dawoodi-navy mb-8">
            Committee Points of Contact
          </h2>

          {/* Male */}
          <div className="mb-12 space-y-3">
            {maleContacts.map((contact, index) => (
              <div key={index} className="bg-white border-2 border-dawoodi-navy/10 rounded-lg p-5 hover:border-dawoodi-gold hover:shadow-md transition-all">
                <p className="font-playfair font-bold text-dawoodi-navy">{contact.name}</p>
                <a
                  href={`tel:${contact.phone.replace(/\D/g, '')}`}
                  className="text-dawoodi-gold font-semibold hover:underline block mt-2"
                >
                  📱 {contact.phone}
                </a>
              </div>
            ))}
          </div>

          {/* Female */}
          <div className="space-y-3">
            {femaleContacts.map((contact, index) => (
              <div key={index} className="bg-white border-2 border-dawoodi-navy/10 rounded-lg p-5 hover:border-dawoodi-gold hover:shadow-md transition-all">
                <p className="font-playfair font-bold text-dawoodi-navy">{contact.name}</p>
                <a
                  href={`tel:${contact.phone.replace(/\D/g, '')}`}
                  className="text-dawoodi-gold font-semibold hover:underline block mt-2"
                >
                  📱 {contact.phone}
                </a>
              </div>
            ))}
          </div>
        </div>

        
      </div>
                  {/* Deceased Form ONLY */}
        <div className="mb-16 flex justify-center">
          <div className="bg-gradient-to-br from-dawoodi-navy to-dawoodi-navy text-white rounded-2xl p-8 max-w-lg text-center hover:shadow-2xl transition-all">
            <div className="text-6xl mb-6">📄</div>
            <h3 className="font-playfair text-2xl font-bold mb-4">Guzarnar Bio-Data Form</h3>
            <a
              href="https://drive.google.com/uc?export=download&id=1DlobTDu5GkLWkF7XkUqrB9-CGIQXJSiu"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-dawoodi-gold text-dawoodi-navy font-bold px-8 py-4 rounded-xl hover:bg-yellow-300 transition-colors"
            >
              <FileText className="w-5 h-5" />
              <span>Access Form</span>
            </a>
          </div>
        </div>

    </div>
  );
}